import { ErrorState, LoadingState } from "@nt/ui/states";
import type { ReactNode } from "react";

export interface QueryLike<T> {
  isPending: boolean;
  isError: boolean;
  error: unknown;
  data: T | undefined;
  refetch: () => unknown;
}

/** Loading (skeleton rows), error (with the recovery sentence and a retry) or the loaded view. */
export function QueryView<T>({
  query,
  what,
  rows,
  children,
}: {
  query: QueryLike<T>;
  what: string;
  /** Skeleton rows while loading. */
  rows?: number;
  children: (data: T) => ReactNode;
}) {
  if (query.isPending) {
    return (
      <LoadingState variant="skeleton" rows={rows} label={`Loading ${what}`} />
    );
  }
  if (query.isError || query.data === undefined) {
    return (
      <ErrorState
        title={`We could not load ${what}`}
        description={
          query.error instanceof Error ? query.error.message : undefined
        }
        recovery="Check your connection and try again. If it keeps failing, write to support@nonresident.tax."
        onRetry={() => void query.refetch()}
      />
    );
  }
  return <>{children(query.data)}</>;
}
